import { Component, Inject, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationModalConfig } from '../../../shared/components/confirmation-modal/confirmation-modal.component';

@Component({
    selector: 'gtw-client-confirm-action',
    template: `
    <gtw-confirmation-modal
      [config]="modalConfig"
      [visible]="false"
      (confirmed)="onConfirm()"
      (cancelled)="onCancel()"
      (closed)="onCancel()">
    </gtw-confirmation-modal>
  `,
    styles: [`
    :host {
      display: block;
    }
  `],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientConfirmActionComponent {
  modalConfig: ConfirmationModalConfig = {
    title: 'Change Client',
    message: 'Are you sure you want to change the client. All open activities will be cleared.',
    iconClass: 'fa fa-sign-out',
    iconColor: 'txt-color-orange-dark',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonClass: 'btn-danger',
    cancelButtonClass: 'btn-default',
    showCancelButton: true,
    showConfirmButton: true,
    animationClass: 'animated fadeIn fast',
    loading: false
  };

  constructor(
    @Optional() private dialogRef?: MatDialogRef<ClientConfirmActionComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: { clientName?: string }
  ) {}

  onConfirm(): void {
    this.dialogRef?.close(true);
  }

  onCancel(): void {
    this.dialogRef?.close(false);
  }
}
